import { Record } from 'immutable'

export const AnalyticsRecord = Record(
  {
    error: null,
  },
  'Analytics'
)

export default class Analytics extends AnalyticsRecord {}
